import { useMemo } from 'react';

import { useKnownAvailableParams } from '@change-corgi/core-react/router';

import { type Draft, useStartAPetitionPageState } from 'src/app/pages/startAPetitionV2/pageContext';
import { useQueryParamValue } from 'src/app/shared/hooks/location';
import { useTrackView } from 'src/app/shared/hooks/tracking';

type GetterFn = (draft?: Draft | null) => Record<string, unknown>;
type TrackingData = Readonly<Record<string, GetterFn | undefined>>;
const TRACKING_DATA: TrackingData = {
	recommendations: (draft) => ({
		ai_recommended_angles:
			draft?.input?.recommendations?.map(({ recommendation, why }, index) => ({
				position: index + 1,
				recommendation,
				why,
			})) ?? [],
	}),
};

export function useTrackPageView(): void {
	const { step } = useKnownAvailableParams<{ step: string }>();
	const { data } = useStartAPetitionPageState();

	const formattedStep = useMemo(() => step.replace(/-/g, '_').toLowerCase(), [step]);
	const trackingData = TRACKING_DATA[formattedStep]?.(data.draft) ?? {};

	useTrackView(`sap_${formattedStep}_view`, trackingData);
}

export function useTrackPageState(): void {
	const { step } = useKnownAvailableParams<{ step: string }>();
	const { data } = useStartAPetitionPageState();
	const loginMethod = useQueryParamValue('met');

	const formattedStep = useMemo(() => step.replace(/-/g, '_').toLowerCase(), [step]);

	const draftUndefined = data.draft?.petitionDraft === undefined;
	const draftNull = data.draft?.petitionDraft === null;
	const draftValuesNull = data.draft?.petitionDraft?.ask === null || data.draft?.petitionDraft?.description === null;

	useTrackView(`sap_${formattedStep}_state`, {
		step: formattedStep,
		login_method: loginMethod,
		draft: { undefined: draftUndefined, null: draftNull, valuesNull: draftValuesNull },
	});
}
